<div [id]="id" [class]="'alert alert-' + color" role="alert">
    <div class="d-flex justify-content-between align-items-center">
        <h4><i [class]="'bi bi-'+ icon"></i> {{title}}</h4>
        <i class="bi bi-x-circle-fill fs-4 cursor-pointer" (click)="close()"></i>
    </div>
    <p>{{message}}</p>
</div>